import {
    AchPaymentModelDto,
    FederalTaxPaymentModelDto,
    StateTaxPaymentModelDto,
    TaxPaymentAmountModelDto,
} from '@treasury/api/bo';
import { AchPayment } from './ach-payment.entity';
import { TaxAmountDescription } from './ach-payment.types';
import { defaultAchTaxPaymentModelDto } from './data/ach.data';

export class AchTaxPayment<
    T extends FederalTaxPaymentModelDto | StateTaxPaymentModelDto,
> extends AchPayment<T & AchPaymentModelDto> {
    public get type() {
        return '';
    }

    public get taxPeriodEndDate() {
        return this.dto.taxPeriodEndDate ?? '0000-00-00';
    }

    public get taxCode() {
        return this.dto.taxCode ?? '';
    }

    public get taxCodeDescription() {
        return this.dto.taxCodeDescription ?? '';
    }

    public get taxPayerId() {
        return this.dto.taxPayerId ?? '';
    }

    public get payFromAccount() {
        return this.dto.payFromAccount ?? '';
    }

    public get amounts(): TaxAmountDescription[] {
        let amounts: TaxAmountDescription[] = [];
        if (this.dto.paymentAmounts) {
            amounts = (this.dto.paymentAmounts as TaxPaymentAmountModelDto[]).map(
                amount =>
                    <TaxAmountDescription>{
                        amount: amount.amount,
                        description:
                            amount.amountTypeName && amount.amountTypeDescription
                                ? amount.amountTypeDescription
                                : undefined,
                    }
            );
        }
        return amounts;
    }

    public get hasAmountTypes() {
        return this.amounts.some(amount => !!amount.description);
    }

    public get recipientName() {
        return this.dto.recipientName ?? '';
    }

    public get recipientId() {
        return this.dto.recipientIdNumber ?? '';
    }

    public get recipientRoutingNumber() {
        return this.dto.recipientRoutingNumber ?? '';
    }

    public get recipientAccountNumber() {
        return this.dto.recipientAccountNumber ?? '';
    }

    public get recipientAccountType() {
        return this.dto.recipientAccountType ?? '';
    }

    public createDefault(): this {
        return new AchTaxPayment(defaultAchTaxPaymentModelDto) as this;
    }
}
